<template>
  <a-modal destroyOnClose style="height: 80%;overflow-y: auto;" width="80%" v-model="visible" @cancel="close" @ok="handleOk" cancelText="关闭" okText="提交" :closable="false" :maskClosable="false">
    <a-row slot="title" style="margin-bottom: 10px">
      <a-row>
        对话题
        <a-button type="primary" icon="download">
          <a style="color: white" :href="`${$serverHost}api/drill/dialogue/${drill.id}/download_srt`" target="_blank">对话字幕</a>
        </a-button>
        <a-tooltip style="margin-left: 10px;">
          <template slot="title">
            支持导入会影字幕https://huiyingzimu.com/work 英中双语字幕时间轴匹配
          </template>
          <a-button type="primary" icon="download">
            <a style="color: white" :href="`${$serverHost}api/drill/dialogue/${drill.id}/text`" target="_blank">对话全部标注文本</a>
          </a-button>
        </a-tooltip>
      </a-row>
    </a-row>
    <a-spin :spinning="loading">
      <a-row>
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="是否必做">
            <a-radio-group :options="requiredOptions" v-model="drill.required"/>
          </a-form-model-item>
          <a-form-model-item label="题目文字">
            <a-input v-model="drill.text"/>
          </a-form-model-item>
          <a-form-model-item label="题图">
            <CommonUpload :defaultUrl="drill.thumbUri ? `${$ossHost}${drill.thumbUri}`: undefined" @changeImgUri="changeImgUri" path="img/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="对话视频">
            <VideoUpload :defaultUrl="drill.videoUri ? `${this.$ossHost}${drill.videoUri}`: undefined" @changeUri="changeVideoUri" path="audio/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="对话音频">
            <AudioUpload :defaultUrl="drill.audioUri ? `${this.$ossHost}${drill.audioUri}`: undefined" @changeUri="changeAudioUri" path="audio/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="对话字幕">
            <FileContentUpload @changeContent="changeText"/>
            <a-list
              item-layout="vertical"
              :loading="loading"
              :data-source="drill.dialogueItems">
              <a-list-item slot="renderItem" slot-scope="item, index">
                <!-- <a v-if="!item.editable" slot="actions" @click="() => editMarketText(index)">修改文本</a>
                <a v-else slot="actions" @click="() => saveMarketText(index)">保存文本</a> -->
                <a-list-item-meta>
                  <div slot="description">
                    <div v-if="!item.editable">
                      <div>
                        <span :key="index" v-for="(text, index) in item.displayText">
                          {{text.word}}
                        </span>
                      </div>
                      <a-row style="margin-top: 5px">
                        <a-col :span="23">
                          <a-tag :key="index" v-for="(text, index) in item.refText">
                            {{text.word}}
                          </a-tag>
                        </a-col>
                      </a-row>
                    </div>
                    <a-input v-else v-model="item.markedText"/>
                  </div>
                  <a slot="title" style="font-weight: 600">
                    {{ item.actor }}
                    <a style="font-weight: normal;" v-if="!item.editable" @click="() => editMarketText(index)">修改文本</a>
                    <a style="font-weight: normal;" v-else @click="() => saveMarketText(index)">保存文本</a>
                  </a>
                  <a-avatar
                    slot="avatar"
                    :src="actorMap[item.actor].actorUri?`${$ossHost}${actorMap[item.actor].actorUri}`:'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png'"
                  />
                </a-list-item-meta>
                <div>
                  <a-row>
                    <a-col :span="20">
                      <a-row style="margin-top: 5px">
                        <a-col :span="2">图片:</a-col>
                        <a-col :span="22">
                          <CommonUpload :defaultUrl="item.imageUri ? `${$ossHost}${item.imageUri}`: undefined" @changeImgUri="(uri) => changeItemImgUri(uri, index)" path="img/drill/"/>
                        </a-col>
                      </a-row>
                      <a-row style="margin-top: 5px">
                        <a-col :span="2">提示:</a-col>
                        <a-col :span="22">
                          <a-input v-model="item.tips"/>
                        </a-col>
                      </a-row>
                      <a-row style="margin-top: 5px">
                        <a-col :span="2">翻译:</a-col>
                        <a-col :span="22">
                          <a-input v-model="item.translatedText"/>
                        </a-col>
                      </a-row>
                      <a-row style="margin-top: 5px">
                        <a-col :span="2">解析:</a-col>
                        <a-col :span="22">
                          <a-input v-model="item.note"/>
                        </a-col>
                      </a-row>
                      <a-row style="margin-top: 5px">
                        <a-col :span="2">主题词组:</a-col>
                        <a-col :span="22">
                          <a-input v-model="item.subjectWords"/>
                        </a-col>
                      </a-row>
                    </a-col>
                    <a-col>
                      
                    </a-col>
                  </a-row>
                </div>
              </a-list-item>
            </a-list>
          </a-form-model-item>
          <a-form-model-item label="可读角色">
            <a-row v-for="(actor, actorIndex) in drill.actorList" :key="actor.label">
              <a-col :span="4">
                <CommonUpload :defaultUrl="actor.actorUri ? `${$ossHost}${actor.actorUri}`: undefined" @changeImgUri="(uri) => changeActorImgUri(actorIndex, uri)" path="img/drill/"/>
              </a-col>
              <a-col :span="12">
                {{actor.label}}
                <a-checkbox style="margin-left: 10px;" v-model="actor.playable" @change="(e) => changeActorPlayable(e.target.checked, actorIndex)">
                  可扮演
                </a-checkbox>
              </a-col>
            </a-row>
          </a-form-model-item>
          <a-form-model-item label="解析">
            <a-textarea style="width: 80%" v-model="drill.explanation" placeholder="请输入解析"/>
          </a-form-model-item>
        </a-form-model>
      </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
import {mapActions} from "vuex";
const OSS = require('ali-oss')
const letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
import AudioUpload from '../../../../components/AudioUpload.vue'
import VideoUpload from '../../../../components/VideoUpload.vue'
import CommonUpload from '../../../../components/CommonUpload.vue'
import FileContentUpload from '../../../../components/FileContentUpload.vue'
import DialogueDrillApi from '../../../../api/src/drill/api/DialogueDrillApi.js'
import DrillApi from '../../../../api/src/drill/api/DrillApi.js'
import Row from '../../../chip/lib/row.vue';
const dialogueDrillApi = new DialogueDrillApi()
const drillApi = new DrillApi()
export default {
  name: "DialogueEdit",
  props: {
    visibleTimes: Number,
    info: Object,
    treeData: Array,
    subType: Number,
    selectedKeys: Array,
    currentDrillId: String,
    sectionId: String,
  },
  components: {AudioUpload, VideoUpload, FileContentUpload, CommonUpload, Row},
  watch: {
    'visibleTimes': async function(a, b) {
      this.visible = true
      this.actorMap = {}
      if(this.currentDrillId){
        console.debug(this.currentDrillId)
        this.loading = true
        let resp = await dialogueDrillApi.getDetail(this.currentDrillId)
        this.assignDrillFromResp(resp)
        console.debug(resp)
        this.loading = false
        return
      }
    },
  },
  data() {
    return {
      letter: letter,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
      requiredOptions: [{
        value: false,
        label: '否'
      },{
        value: true,
        label: '是'
      }],
      drill: {
        audioUri: undefined,
        required: false,
        text: undefined,
        mode: 0,
        explanation: undefined,
        dialogueItems: undefined,
        playableActorList: []
      },
      fragmentList: [],
      uploading: false,
      loading: false,
      visible: false,
      actorMap: {}
    }
  },
  methods:{
    normalizeActorList(actorList) {
      return (actorList || []).map(actor => ({
        label: actor.label,
        actorUri: actor.actorUri,
        playable: Boolean(actor.playable)
      }))
    },
    syncActorMap(actorList) {
      const map = {}
      actorList.forEach(actor => {
        map[actor.label] = actor
      })
      this.actorMap = map
    },
    assignDrillFromResp(resp) {
      const drill = JSON.parse(JSON.stringify(resp))
      if (drill.audioUri) {
        drill.audioUrl = `${this.$ossHost}${drill.audioUri}`
      }
      drill.actorList = this.normalizeActorList(drill.actorList)
      this.syncActorMap(drill.actorList)
      this.drill = drill
    },
    changeItemImgUri(uri, index) {
      this.drill.dialogueItems[index].imageUri = uri
    },
    async saveMarketText(index) {
      this.loading = true
      let markedText = this.drill.dialogueItems[index].markedText
      console.log(markedText)
      let resp = await drillApi.parseMarkedText(markedText)
      console.log(resp)
      let dialogueItems = [...this.drill.dialogueItems]
      dialogueItems[index].displayText = resp.displayText
      dialogueItems[index].refText = resp.refText
      dialogueItems[index].editable = false
      this.drill.dialogueItems = dialogueItems
      this.loading = false
    },
    editMarketText(index) {
      let dialogueItems = [...this.drill.dialogueItems]
      dialogueItems[index].editable = true
      this.drill.dialogueItems = dialogueItems
      console.log(this.drill)
    },
    changeImgUri(uri) {
      this.drill.thumbUri = uri
      console.log(uri)
    },
    changeActorImgUri(index, uri) {
      console.log(index, uri)
      let actorList = this.drill.actorList
      actorList[index].actorUri = uri
      this.actorMap[actorList[index].label].actorUri = uri
      this.drill.actorList = actorList
    },
    changeActorPlayable(checked, index) {
      if (!checked) {
        return
      }
      this.drill.actorList = this.drill.actorList.map((actor, i) => ({
        label: actor.label,
        actorUri: actor.actorUri,
        playable: i === index
      }))
      this.syncActorMap(this.drill.actorList)
    },
    changeAudioUri(uri) {
      this.drill.audioUri = uri
      console.log(uri)
    },
    changeVideoUri(uri) {
      this.drill.videoUri = uri
      console.log(uri)
    },
    async changeText(text) {
      console.log(text)
      let resp = await dialogueDrillApi.parseSrt(text)
      resp.map(item => {item.newline = true})
      console.log(resp)
      this.drill.dialogueItems = resp
      const actorList = this.normalizeActorList(
        [...new Set(resp.map(item => item.actor))].map(label => ({ label, playable: false }))
      )
      this.syncActorMap(actorList)
      this.drill.actorList = actorList
    },
    changeDrillText(e) {
      console.debug(e.target.value)
      let fillingNum = e.target.value.split('[]').length - 1
      if(this.drill.correctAnswerSource.length < fillingNum){
        this.drill.correctAnswerSource = this.drill.correctAnswerSource.concat(new Array(fillingNum - this.drill.correctAnswerSource.length).fill({
          value: ''
        }))
      }else if(this.drill.correctAnswerSource.length > fillingNum){
        this.drill.correctAnswerSource = this.drill.correctAnswerSource.slice(0, fillingNum)
      }
    },
    beforeUpload(file) {
      let fragment = {
        title: undefined,
        type: 1,
        summary: undefined,
        isVideo: false,
        knowledgeId: this.info.knowledgeId,
        progress: 0,
        file: file
      }
      if(/video/ig.test(fragment.file.type)){
        fragment.isVideo = true
      }
      this.fragmentList.push(fragment)
      return false
    },
    handleChangeFile(e) {
    },
    handlePreview() {

    },
    getDetail() {

    },
    close() {
      if(this.loading){
        this.$message.warning('试题正在上传中，请稍后')
        return
      }
      this.$emit('success', {addDrill: true})
      this.visible = false
      this.drill = {
        audioUri: undefined,
        required: false,
        text: undefined,
        mode: 0,
        explanation: undefined,
        dialogueItems: undefined,
        playableActorList: []
      }
    },
    deleteFile(fragment, index) {
    },
    async handleOk() {
      console.log(this.drill)
      if(!this.drill.dialogueItems){
        this.$message.error('请上传对话字幕文件')
        return
      }
      if(!this.drill.audioUri && !this.drill.videoUri){
        this.$message.error('请上传对话音频或视频')
        return
      }
      if(!this.drill.text){
        this.$message.error('请填写题目文字')
        return
      }
      if(!this.drill.id){
        this.drill.subType = this.subType
      }
      console.debug(this.drill)
      console.debug(this.$route.params.courseStandardId)
      console.debug(this.selectedKeys[0])
      this.loading = true
      if(!this.drill.id){
        await dialogueDrillApi.create(this.drill, {
          courseStandardId: this.$route.params.courseStandardId,
          knowledgeId: this.selectedKeys[0],
          sectionId: this.sectionId,
          sortKey: 0
        })
      }else{
        await dialogueDrillApi.update(this.drill.id, this.drill)
      }
      this.visible = false
      this.drill = {
        audioUri: undefined,
        required: false,
        text: undefined,
        mode: 0,
        explanation: undefined,
        dialogueItems: undefined,
        playableActorList: []
      }
      this.loading = false
      this.$emit('success', {addDrill: true})
    },
    check() {
      console.log(this.fragmentList)
      let checkFlag = true
      for(let i = 0; i < this.fragmentList.length; i++) {
        if(!this.fragmentList[i].title){
          this.$message.error(`${this.fragmentList[i].file.name}无碎片名`)
          checkFlag = false
          break
        }
        if(!this.fragmentList[i].summary){
          this.$message.error(`${this.fragmentList[i].file.name}无碎片简介`)
          checkFlag = false
          break
        }
      }
      return checkFlag
    },
    async uploadFile(fragment, index) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('fragment/getStsAk', {id: fragment.id}).then(res => {
          let region = res.endpoint;
          let fKey = region.indexOf('//') + 2;
          let lKey = region.indexOf('.');
          let client = new OSS({
            region: region.substring(fKey,lKey),
            accessKeyId: res.accessKeyId,
            accessKeySecret: res.accessKeySecret,
            stsToken: res.securityToken,
            bucket: res.bucketName,
          })
          let tempCheckpoint;
          client.multipartUpload(res.url + fragment.file.name, fragment.file, {
            progress: (p, checkpoint) => {
              // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
              tempCheckpoint = checkpoint;
              this.fragmentList[index].progress = Math.floor(p * 100)
              if(p == 1){
                let endpointPath = res.endpoint.split('/')
                let endpoint = endpointPath[endpointPath.length - 1]
                let url
                if(checkpoint){
                  url = `https://${res.bucketName}.${endpoint}/${checkpoint.name}`;
                }else{
                  url = `https://${res.bucketName}.${endpoint}/${res.url}${fragment.file.name}`
                }
                this.addFragment({uri: res.url + fragment.file.name, url, type: fragment.type, fragment}, {resolve, reject})
              }
            },
          }).catch(err => {
            console.log(err)
          })

        })
      })
    },
    addFragment(data, {resolve, reject}){
      const reqData = {
        id: data.fragment.id,
        mediaUrl: data.uri,
        type: data.type,
      }
      this.$store.dispatch('fragment/addFragmentRes', reqData).then(res=>{
        resolve({url: data.url, title: data.fragment.file.name })
      })
    },
    changeCorrectAnswer(e, optionIndex) {
      console.debug(e.target.checked)
      console.debug(optionIndex)
      if(e.target.checked && (this.subType == 101 || this.subType == 103)){
        this.drill.optionList.map(option => {
          option.correctAnswer = false
        })
        this.drill.optionList[optionIndex].correctAnswer = true
      }
    }
  }
}
</script>

<style scoped lang="less">
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 10px;
}
.dynamic-delete-button:hover {
  color: #777;
}
</style>